module.exports = "/fonts/fa-regular-400.ttf?c7a40b90b6180f4a0bd08762dafab054";